module.exports = __webpack_public_path__ + "static/media/YonderMountainStringBandCabinFevrTour2012handdrawn3colorscreenprint.7a96e60b.webp";